import { Trans } from '~/common/context';
import {
  Button,
  Col,
  Flex,
  Icon,
  Text,
  DndProvider,
  DragHandle,
  SortableItem,
} from '@wyz/ui';
import * as React from 'react';
import { SupplierButton } from '~/connect/components';
import { ICustomerInternalStockFormItem } from '~/connect/types';

type Props = {
  suppliers?: Array<ICustomerInternalStockFormItem>;
  onMove: (indexA: number, indexB: number) => void;
  onRemove: (index: number) => void;
  mode: 'WRITE' | 'READ_ONLY';
};

const InternalStocksDraggables: React.FC<Props> = ({
  suppliers = [],
  onMove,
  onRemove,
  mode,
}) => {
  return (
    <DndProvider
      items={suppliers}
      onMove={onMove}
      getId={(item) => item.id}
      renderItem={(supplier, index) => (
        <SortableItem id={supplier.id}>
          <div className='d-flex align-items-center'>
            <Col md={1}>
              <Text heading='normal' color='tertiary' weight='bold'>
                {index + 1}
              </Text>
            </Col>
            <Col md={11}>
              <SupplierButton>
                <Flex alignItems='center' justifyContent='between'>
                  <span className='ms-4'>{supplier.name}</span>
                  <div
                    className='hoverable-btn position-absolute'
                    style={{ right: 0 }}
                  >
                    {mode !== 'READ_ONLY' && (
                      <div className='space-x-2 d-flex bg-neutral-grey-2'>
                        <Button
                          id={`remove-${supplier.id}`}
                          variant='tertiary-grey'
                          size='sm'
                          onClick={() => onRemove(index)}
                        >
                          <Icon icon='minus' width={20} height={20} />
                          <span>
                            <Trans i18nKey='app.common.buttons.remove' />
                          </span>
                        </Button>
                        <DragHandle id={`drag-${supplier.name}`} />
                      </div>
                    )}
                  </div>
                </Flex>
              </SupplierButton>
            </Col>
          </div>
        </SortableItem>
      )}
    ></DndProvider>
  );
};
export default InternalStocksDraggables;
